import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FormlyFormOptions, FormlyModule } from '@ngx-formly/core';
import { takeWhile } from 'rxjs';
import { markFormGroupsTouched } from '../../utils/reactive-form/reactive-form.util';
import { LandUseClassFormModel } from './services/land-use-class-form/land-use-class-form.model';
import { LandUseClassFormService } from './services/land-use-class-form/land-use-class-form.service';

@Component({
  selector: 'gk-land-use-class-form',
  template: `
    @let fields = (formlyFormConfig | async).fields;
    @if (fields) {
      <form>
        <formly-form
          [form]="form"
          [fields]="fields"
          [options]="options"
          [model]="formModel"
        ></formly-form>
      </form>
    }
  `,
  imports: [CommonModule, ReactiveFormsModule, FormlyModule],
})
export class LandUseClassFormComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  @Input() form: FormGroup;
  @Input() options: FormlyFormOptions;
  @Input() submitted: boolean;
  formModel: LandUseClassFormModel;
  formlyFormConfig = this.landUseClassFormService.getFormConfig();
  private isAlive = true;

  constructor(private landUseClassFormService: LandUseClassFormService) {}

  ngOnInit(): void {
    this.initializeFormModel();
  }

  ngAfterViewInit(): void {
    if (this.submitted) {
      markFormGroupsTouched(this.form);
    }
  }

  initializeFormModel(): void {
    this.landUseClassFormService
      .getFormModel()
      .pipe(takeWhile(() => this.isAlive))
      .subscribe((formModel) => {
        if (formModel) {
          this.formModel = formModel;
        }
      });
  }

  ngOnDestroy(): void {
    this.isAlive = false;
  }
}
